import { enrichResultsUrlWithStoredDispatchContext } from "./dispatchDateUrls.js";

const NAV_KEY_BY_PATH = {
  "/accueil": "home",
  "/admin": "admin",
  "/admin/local-tools": "local-tools",
  "/admin/automations": "automations",
  "/billing": "billing",
  "/consolidation": "consolidation",
  "/dashboard": "dashboard",
  "/driver-accounts": "driver-accounts",
  "/portail": "portal",
  "/updates": "updates",
  "/dev/animation-chargement": "updates",
  "/orders": "data-manager",
  "/import": "import",
  "/reports": "reports",
  "/data-manager": "data-manager",
  "/system-config": "system-config",
  "/captures": "dispatch-captures",
  "/system-config/dispatch-alert-captures": "dispatch-captures",
  "/system-config/reassignment-diagnostics": "dispatch-captures",
  "/results": "affectation",
  "/results/latest": "affectation",
  "/geotab": "geotab",
};

const TEMPORARILY_DISABLED_NAV_ITEM_BY_KEY = {
  results: {
    disabled_reason: "Entrée temporairement désactivée pendant la définition de cette vue.",
  },
};

const SHELL_HEADER_FALLBACKS_BY_PATH = {
  "/accueil": {
    eyebrow: "Espace opérateur",
    subtitle: "Point d’entrée léger vers les outils du SaaS.",
    title: "Accueil",
  },
  "/dashboard": {
    eyebrow: "Dispatch Overview",
    subtitle: "Résumé opérationnel de la flotte.",
    title: "Tableau de bord",
  },
  "/driver-accounts": {
    eyebrow: "Accès chauffeurs",
    subtitle: "Créer les comptes portail chauffeur, vérifier leur liaison camion et suivre leur statut sans ouvrir l'Admin RBAC complet.",
    title: "Comptes chauffeurs",
  },
  "/portail": {
    eyebrow: "Portail chauffeurs",
    subtitle: "Ouvrir la vue terrain dédiée aux chauffeurs et aux opérateurs autorisés sans passer par le cockpit SaaS.",
    title: "Portail",
  },
  "/geotab": {
    eyebrow: "Suivi terrain",
    subtitle: "Comparer le Dispatch aux trajets réels Geotab et suivre les camions en direct.",
    title: "Geotab",
  },
  "/updates": {
    eyebrow: "Historique produit",
    subtitle: "Relire les nouveautés du SaaS, les correctifs publiés et les annonces de maintenance dans l'ordre antichronologique.",
    title: "Journal",
  },
  "/dev/animation-chargement": {
    eyebrow: "Aperçu UI",
    subtitle: "Visualiser le déplacement du camion sur la voie de chargement de la barre du haut.",
    title: "Animation chargement",
  },
  "/orders": {
    eyebrow: "Contrôle commandes",
    subtitle: "Lecture compacte des lignes visibles, avec statut dispatch, échéance et volume exploitable.",
    title: "Commandes actives",
  },
  "/import": {
    eyebrow: "Mise à jour source",
    subtitle: "Import protégé des données source synchronisées vers PostgreSQL.",
    title: "Import fichiers",
  },
  "/reports": {
    eyebrow: "Rapports",
    subtitle: "Générer les rapports PDF métier centralisés avec une date et une meunerie ciblées.",
    title: "Rapports",
  },
  "/data-manager": {
    eyebrow: "Gestion données",
    subtitle: "Créer et ajuster les commandes, véhicules et compartiments sans ouvrir le cockpit Dispatch à une édition lourde.",
    title: "Data Manager",
  },
  "/admin": {
    eyebrow: "Administration RBAC",
    subtitle: "Attribuer les rôles, éditer la matrice des permissions et consulter l'audit d'accès dans une surface dédiée.",
    title: "Admin",
  },
  "/admin/local-tools": {
    eyebrow: "Administration locale",
    subtitle: "Échanger les données et les caches entre ce poste et Railway.",
    title: "Outils locaux",
  },
  "/admin/automations": {
    eyebrow: "Administration",
    subtitle: "Planifier des actions métier et des rappels persistants dans le SaaS.",
    title: "Tâches planifiées",
  },
  "/billing": {
    eyebrow: "Administration",
    subtitle: "Préparer et envoyer les relevés de transport.",
    title: "Facturation",
  },
  "/consolidation": {
    eyebrow: "Facturation",
    subtitle: "Rapprocher les rapports chauffeurs et préparer les prestations facturables.",
    title: "Consolidation",
  },
  "/system-config": {
    eyebrow: "Paramètres globaux",
    subtitle: "Ajuster les valeurs par défaut du calcul et les tolérances.",
    title: "Paramètres système",
  },
  "/captures": {
    eyebrow: "",
    subtitle: "",
    title: "Captures",
  },
  "/system-config/dispatch-alert-captures": {
    eyebrow: "Diagnostic Dispatch",
    subtitle: "Consulter les PNG privés des alertes capturées dans les navigateurs ciblés.",
    title: "Captures des alertes Dispatch",
  },
  "/system-config/reassignment-diagnostics": {
    eyebrow: "Diagnostic Dispatch",
    subtitle: "Consulter l’historique cumulé des timings de réaffectation Dispatch.",
    title: "Activité Dispatch",
  },
  "/results": {
    eyebrow: "Pilotage dispatch",
    subtitle: "Pilotage courant des routes, des camions et des panneaux d'analyse sans quitter le shell.",
    title: "Dispatch",
  },
  "/results/latest": {
    eyebrow: "Pilotage dispatch",
    subtitle: "Alias de compatibilité vers Dispatch avec la même carte, les mêmes diagnostics et les mêmes actions métier.",
    title: "Dispatch",
  },
};

const NAV_SECTION_HOVER_DESCRIPTIONS_BY_LABEL = {
  Principal: "Regroupe les écrans d'entrée du planning: synthèse et import des sources.",
  Opérations: "Regroupe le cockpit Dispatch et la surface dédiée à l’édition contrôlée des données métier.",
  Portail: "Regroupe l’accès rapide au portail chauffeur et la gestion des comptes liés aux camions.",
  Analyse: "Regroupe les paramètres, les captures et le Journal.",
  Facturation: "Regroupe la consolidation des prestations et les relevés de transport.",
  Admin: "Regroupe les surfaces d'administration des rôles, permissions et audits d'accès.",
};

const NAV_ITEM_HOVER_DESCRIPTIONS_BY_KEY = {
  admin: "Administrer les affectations RBAC, les rôles et l'audit d'accès dans une vue dédiée.",
  automations: "Créer, planifier et surveiller les tâches automatiques et les notifications internes.",
  billing: "Préparer et envoyer les relevés de transport aux entreprises facturées.",
  consolidation: "Rapprocher les rapports chauffeurs et préparer les prestations à facturer.",
  dashboard: "Vue de synthèse pour suivre rapidement les commandes, les camions, le tonnage et les alertes visibles.",
  "driver-accounts": "Créer et lier les comptes portail chauffeur sans ouvrir la console Admin RBAC.",
  portal: "Ouvrir le portail chauffeur tel qu'il est vu par les comptes dédiés au terrain.",
  updates: "Historique des nouveautés, correctifs et annonces déjà publiés dans l'application.",
  import: "Mettre à jour les données source",
  reports: "Générer les rapports PDF métier centralisés, à commencer par la sortie meunerie par date et par site.",
  "data-manager": "Créer et ajuster les commandes, véhicules et compartiments avec une logique séparée du cockpit Dispatch.",
  "system-config": "Ajuster les paramètres globaux du moteur, des coûts et des tolérances métier.",
  "dispatch-captures": "Consulter l’activité Dispatch, les captures d’erreurs et les imports de commandes Sollio/Uniag.",
  affectation: "Gérer les routes et camions",
  geotab: "Comparer le Dispatch aux trajets réels et suivre les camions en direct.",
  results: "Dernière optimisation sauvegardée",
};

function findNavItemLabel(navSections, targetKey) {
  if (!Array.isArray(navSections) || !targetKey) {
    return "";
  }

  const walkItems = (items) => {
    for (const item of items) {
      if (!item || typeof item !== "object") {
        continue;
      }

      const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
      const detailViewLink = typeof item.detail_view_link === "string"
        ? item.detail_view_link.trim().toLowerCase()
        : "";

      if (itemKey === targetKey || detailViewLink === targetKey) {
        return typeof item.label === "string" ? item.label : "";
      }

      const nestedLabel = walkItems(getNavSubItems(item));
      if (nestedLabel) {
        return nestedLabel;
      }
    }

    return "";
  };

  for (const section of navSections) {
    const match = walkItems(section?.items || []);
    if (match) {
      return match;
    }
  }

  return "";
}

export function getNavItemKey(item, fallbackKey = "nav-item") {
  if (item && typeof item.key === "string" && item.key.trim()) {
    return item.key.trim();
  }

  if (item && typeof item.label === "string" && item.label.trim()) {
    return `${fallbackKey}-${item.label.trim().toLowerCase().replace(/\s+/g, "-")}`;
  }

  return fallbackKey;
}

export function getNavSubItems(item) {
  if (!item || typeof item !== "object") {
    return [];
  }

  const subItemCandidates = [item.sub_items, item.subItems, item.children];
  const resolvedSubItems = subItemCandidates.find((candidate) => Array.isArray(candidate) && candidate.length > 0);

  if (Array.isArray(resolvedSubItems)) {
    return resolvedSubItems.filter((candidate) => candidate && typeof candidate === "object");
  }

  return [];
}

export function hasActiveNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  if (item.is_active || item.aria_current) {
    return true;
  }

  return getNavSubItems(item).some((subItem) => hasActiveNavItem(subItem));
}

export function getActiveNavKeyFromSections(navSections) {
  if (!Array.isArray(navSections)) {
    return null;
  }

  const walkItems = (items) => {
    for (const item of items) {
      if (!item || typeof item !== "object") {
        continue;
      }

      if (item.is_active || item.aria_current) {
        return getNavItemKey(item, "nav-item");
      }

      const nestedActiveKey = walkItems(getNavSubItems(item));
      if (nestedActiveKey) {
        return nestedActiveKey;
      }
    }

    return null;
  };

  for (const section of navSections) {
    const activeNavKey = walkItems(section?.items || []);
    if (activeNavKey) {
      return activeNavKey;
    }
  }

  return null;
}

export function getInitialOpenNavItemKey(navSections) {
  if (!Array.isArray(navSections)) {
    return null;
  }

  for (const [sectionIndex, section] of navSections.entries()) {
    for (const [itemIndex, item] of (section.items || []).entries()) {
      const subItems = getNavSubItems(item);

      if (subItems.length === 0) {
        continue;
      }

      if (item.is_active || item.aria_current || subItems.some((subItem) => hasActiveNavItem(subItem))) {
        return getNavItemKey(item, `nav-section-${sectionIndex}-item-${itemIndex}`);
      }
    }
  }

  return null;
}

export function getPathnameNavKey(pathname) {
  return NAV_KEY_BY_PATH[pathname] || "dashboard";
}

// Section envoyée avec le signal de présence (colonne « En ligne » de l'Admin) : page exacte, sinon la plus proche parente.
export function getPathnameSectionLabel(pathname) {
  let path = typeof pathname === "string" ? pathname.replace(/\/+$/, "") : "";
  while (path) {
    if (SHELL_HEADER_FALLBACKS_BY_PATH[path]) {
      return SHELL_HEADER_FALLBACKS_BY_PATH[path].title;
    }
    path = path.slice(0, path.lastIndexOf("/"));
  }
  return "";
}

export function getShellHeaderFallback(pathname, navSections, activeNavKeyOverride = null) {
  const fallback = SHELL_HEADER_FALLBACKS_BY_PATH[pathname] || SHELL_HEADER_FALLBACKS_BY_PATH["/dashboard"];
  const navLabel = findNavItemLabel(navSections, activeNavKeyOverride || getPathnameNavKey(pathname));

  return {
    eyebrow: fallback.eyebrow,
    subtitle: fallback.subtitle,
    title: navLabel || fallback.title,
  };
}

export function resolveNavSectionHoverDescription(section) {
  const explicitDescription = typeof section?.description === "string"
    ? section.description.trim()
    : "";

  if (explicitDescription) {
    return explicitDescription;
  }

  const label = typeof section?.label === "string" ? section.label.trim() : "";
  return NAV_SECTION_HOVER_DESCRIPTIONS_BY_LABEL[label] || "";
}

export function resolveNavItemHoverDescription(item) {
  const explicitDescription = typeof item?.description === "string"
    ? item.description.trim()
    : "";

  if (explicitDescription) {
    return explicitDescription;
  }

  const key = typeof item?.key === "string" ? item.key.trim() : "";
  return NAV_ITEM_HOVER_DESCRIPTIONS_BY_KEY[key] || "";
}

function isProductUpdatesNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";

  if (itemKey === "updates" || itemHref === "/updates") {
    return true;
  }

  return getNavSubItems(item).some((subItem) => isProductUpdatesNavItem(subItem));
}

function isControlCenterNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemLabel = typeof item.label === "string" ? item.label.trim().toLowerCase() : "";

  return itemKey === "diagnostic" || itemLabel === "centre de contrôle";
}

function isSystemConfigNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";

  return itemKey === "system-config";
}

function isAdminNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";

  if (itemKey === "admin" || itemHref === "/admin") {
    return true;
  }

  return getNavSubItems(item).some((subItem) => isAdminNavItem(subItem));
}

function isAutomationsNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }
  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";
  return itemKey === "automations" || itemHref === "/admin/automations";
}

function isDriverAccountsNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";

  if (itemKey === "driver-accounts" || itemHref === "/driver-accounts") {
    return true;
  }

  return getNavSubItems(item).some((subItem) => isDriverAccountsNavItem(subItem));
}

function normalizeNavSectionLabel(section) {
  return typeof section?.label === "string" ? section.label.trim().toLowerCase() : "";
}

function insertNavItemIntoPortalSection(navSections, navItem, navItemMatcher, { insertAtStart = false } = {}) {
  if (!Array.isArray(navSections) || navSections.length === 0) {
    return navSections;
  }

  const sanitizedSections = navSections.map((section) => {
    const items = Array.isArray(section?.items) ? section.items : [];
    return {
      ...section,
      items: items.filter((item) => !navItemMatcher(item)),
    };
  });
  const portalSectionIndex = sanitizedSections.findIndex((section) => normalizeNavSectionLabel(section) === "portail");
  const nextPortalItems = (() => {
    if (portalSectionIndex < 0) {
      return [navItem];
    }

    const currentPortalItems = Array.isArray(sanitizedSections[portalSectionIndex]?.items)
      ? sanitizedSections[portalSectionIndex].items
      : [];
    return insertAtStart
      ? [navItem, ...currentPortalItems]
      : [...currentPortalItems, navItem];
  })();

  if (portalSectionIndex >= 0) {
    return sanitizedSections.map((section, index) => {
      if (index !== portalSectionIndex) {
        return section;
      }

      return {
        ...section,
        items: nextPortalItems,
      };
    });
  }

  const portalSection = {
    label: "Portail",
    items: nextPortalItems,
  };
  const insertBeforeSectionIndex = sanitizedSections.findIndex((section) => {
    const sectionLabel = normalizeNavSectionLabel(section);
    return sectionLabel === "analyse" || sectionLabel === "admin";
  });

  if (insertBeforeSectionIndex < 0) {
    return [...sanitizedSections, portalSection];
  }

  return [
    ...sanitizedSections.slice(0, insertBeforeSectionIndex),
    portalSection,
    ...sanitizedSections.slice(insertBeforeSectionIndex),
  ];
}

export function injectDriverAccountsNavItem(navSections, { hasAccess = true } = {}) {
  if (!Array.isArray(navSections) || navSections.length === 0 || !hasAccess) {
    return navSections;
  }

  const driverAccountsNavItem = {
    href: "/driver-accounts",
    icon: "driver-accounts",
    key: "driver-accounts",
    label: "Comptes chauffeurs",
  };

  return insertNavItemIntoPortalSection(navSections, driverAccountsNavItem, isDriverAccountsNavItem);
}

export function injectProductUpdatesNavItem(navSections) {
  if (!Array.isArray(navSections) || navSections.length === 0) {
    return navSections;
  }

  const hasExistingUpdatesNavItem = navSections.some((section) => (
    (Array.isArray(section?.items) ? section.items : []).some((item) => isProductUpdatesNavItem(item))
  ));

  if (hasExistingUpdatesNavItem) {
    return navSections;
  }

  const updatesNavItem = {
    href: "/updates",
    icon: "updates",
    key: "updates",
    label: "Journal",
  };
  let hasInsertedUpdatesNavItem = false;
  const sectionsWithUpdatesNavItem = navSections.map((section) => ({
    ...section,
    items: (() => {
      const sectionItems = Array.isArray(section?.items) ? section.items : [];
      const systemConfigIndex = sectionItems.findIndex((item) => isSystemConfigNavItem(item));
      const insertAfterIndex = systemConfigIndex >= 0
        ? systemConfigIndex
        : sectionItems.findIndex((item) => isControlCenterNavItem(item));

      if (insertAfterIndex < 0) {
        return sectionItems;
      }

      hasInsertedUpdatesNavItem = true;

      return [
        ...sectionItems.slice(0, insertAfterIndex + 1),
        updatesNavItem,
        ...sectionItems.slice(insertAfterIndex + 1),
      ];
    })(),
  }));

  if (hasInsertedUpdatesNavItem) {
    return sectionsWithUpdatesNavItem;
  }

  const analysisSectionIndex = navSections.findIndex((section) => (
    typeof section?.label === "string" && section.label.trim().toLowerCase() === "analyse"
  ));

  if (analysisSectionIndex >= 0) {
    return navSections.map((section, index) => {
      if (index !== analysisSectionIndex) {
        return section;
      }

      return {
        ...section,
        items: [...(Array.isArray(section?.items) ? section.items : []), updatesNavItem],
      };
    });
  }

  return [
    {
      label: "Analyse",
      items: [updatesNavItem],
    },
    ...navSections,
  ];
}

export function injectAdminNavSection(navSections, { hasAccess = true } = {}) {
  if (!Array.isArray(navSections) || navSections.length === 0 || !hasAccess) {
    return navSections;
  }

  const hasExistingAdminSection = navSections.some((section) => (
    typeof section?.label === "string" && section.label.trim().toLowerCase() === "admin"
  ));
  const hasExistingAdminNavItem = navSections.some((section) => (
    (Array.isArray(section?.items) ? section.items : []).some((item) => isAdminNavItem(item))
  ));

  if (hasExistingAdminSection || hasExistingAdminNavItem) {
    return navSections;
  }

  const adminSection = {
    label: "Admin",
    items: [
      {
        href: "/admin",
        icon: "admin",
        key: "admin",
        label: "Admin",
      },
    ],
  };

  const insertAfterSectionIndex = navSections.findIndex((section) => (
    (Array.isArray(section?.items) ? section.items : []).some((item) => isProductUpdatesNavItem(item))
      || (typeof section?.label === "string" && section.label.trim().toLowerCase() === "analyse")
  ));

  if (insertAfterSectionIndex < 0) {
    return [...navSections, adminSection];
  }

  return [
    ...navSections.slice(0, insertAfterSectionIndex + 1),
    adminSection,
    ...navSections.slice(insertAfterSectionIndex + 1),
  ];
}

export function injectAutomationsNavItem(navSections, { hasAccess = true } = {}) {
  if (!Array.isArray(navSections)) {
    return navSections;
  }
  const sanitizedSections = navSections
    .map((section) => ({
      ...section,
      items: (Array.isArray(section?.items) ? section.items : []).filter((item) => !isAutomationsNavItem(item)),
    }))
    .filter((section) => normalizeNavSectionLabel(section) || section.items.length > 0);
  if (!hasAccess) {
    return sanitizedSections;
  }
  const item = {
    href: "/admin/automations",
    icon: "automations",
    key: "automations",
    label: "Tâches planifiées",
  };
  const adminSectionIndex = sanitizedSections.findIndex((section) => normalizeNavSectionLabel(section) === "admin");
  const insertionIndex = adminSectionIndex >= 0 ? adminSectionIndex : sanitizedSections.length;
  return [
    ...sanitizedSections.slice(0, insertionIndex),
    { label: "", items: [item] },
    ...sanitizedSections.slice(insertionIndex),
  ];
}

export function injectLocalToolsNavItem(navSections, { hasAccess = false } = {}) {
  const sections = (Array.isArray(navSections) ? navSections : []).map((section) => ({
    ...section,
    items: (section.items || []).filter((item) => item.key !== "local-tools" && item.href !== "/admin/local-tools"),
  }));
  if (!hasAccess) return sections;
  const item = { href: "/admin/local-tools", icon: "local-tools", key: "local-tools", label: "Outils locaux" };
  const admin = sections.find((section) => normalizeNavSectionLabel(section) === "admin");
  if (admin) admin.items.push(item);
  else sections.push({ label: "Admin", items: [item] });
  return sections;
}

function isBillingNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";
  return itemKey === "billing" || itemHref === "/billing";
}

function isConsolidationNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";
  return itemKey === "consolidation" || itemHref === "/consolidation";
}

export function injectBillingNavSection(navSections, { billingAccess = false, consolidationAccess = false, pathname = "" } = {}) {
  if (!Array.isArray(navSections)) {
    return navSections;
  }

  const sanitizedSections = navSections
    .map((section) => ({
      ...section,
      items: (Array.isArray(section?.items) ? section.items : [])
        .filter((item) => !isBillingNavItem(item) && !isConsolidationNavItem(item)),
    }))
    .filter((section) => section.items.length > 0);
  const billingItems = [];
  if (consolidationAccess) {
    billingItems.push({
      key: "consolidation",
      label: "Consolidation",
      href: "/consolidation",
      icon: "consolidation",
      is_active: pathname === "/consolidation",
      aria_current: pathname === "/consolidation",
    });
  }
  if (billingAccess) {
    billingItems.push({ href: "/billing", icon: "billing", key: "billing", label: "Facturation" });
  }
  if (billingItems.length === 0) {
    return sanitizedSections;
  }

  const adminSectionIndex = sanitizedSections.findIndex((section) => normalizeNavSectionLabel(section) === "admin");
  const insertionIndex = adminSectionIndex >= 0 ? adminSectionIndex : sanitizedSections.length;
  return [
    ...sanitizedSections.slice(0, insertionIndex),
    { label: "Facturation", items: billingItems },
    ...sanitizedSections.slice(insertionIndex),
  ];
}

export function buildFallbackNavSections({ activeNavKey }) {
  return [
    {
      label: "Principal",
      items: [
        {
          aria_current: activeNavKey === "dashboard",
          href: "/dashboard",
          icon: "dashboard",
          is_active: activeNavKey === "dashboard",
          key: "dashboard",
          label: "Tableau de bord",
        },
        {
          aria_current: activeNavKey === "import",
          href: "/import",
          icon: "import",
          is_active: activeNavKey === "import",
          key: "import",
          label: "Import fichiers",
        },
        {
          aria_current: activeNavKey === "reports",
          href: "/reports",
          icon: "reports",
          is_active: activeNavKey === "reports",
          key: "reports",
          label: "Rapports",
        },
      ],
    },
    {
      label: "Opérations",
      items: [
        {
          aria_current: activeNavKey === "data-manager",
          href: "/data-manager",
          icon: "data-manager",
          is_active: activeNavKey === "data-manager",
          key: "data-manager",
          label: "Data Manager",
        },
        {
          aria_current: activeNavKey === "affectation",
          href: enrichResultsUrlWithStoredDispatchContext("/results"),
          icon: "affectation",
          is_active: activeNavKey === "affectation",
          key: "affectation",
          label: "Dispatch",
        },
        {
          aria_current: activeNavKey === "geotab",
          href: "/geotab",
          icon: "geotab",
          is_active: activeNavKey === "geotab",
          key: "geotab",
          label: "Geotab",
        },
      ],
    },
    {
      label: "Portail",
      items: [
        {
          aria_current: activeNavKey === "portal",
          href: "/portail",
          icon: "portal",
          is_active: activeNavKey === "portal",
          key: "portal",
          label: "Portail",
        },
        {
          aria_current: activeNavKey === "driver-accounts",
          href: "/driver-accounts",
          icon: "driver-accounts",
          is_active: activeNavKey === "driver-accounts",
          key: "driver-accounts",
          label: "Comptes chauffeurs",
        },
      ],
    },
    {
      label: "Analyse",
      items: [
        {
          aria_current: activeNavKey === "system-config",
          href: "/system-config",
          icon: "system-config",
          is_active: activeNavKey === "system-config",
          key: "system-config",
          label: "Param. systèmes",
        },
        {
          aria_current: activeNavKey === "dispatch-captures",
          href: "/captures",
          icon: "dispatch-captures",
          is_active: activeNavKey === "dispatch-captures",
          key: "dispatch-captures",
          label: "Captures",
        },
        {
          aria_current: activeNavKey === "updates",
          href: "/updates",
          icon: "updates",
          is_active: activeNavKey === "updates",
          key: "updates",
          label: "Journal",
        },
      ],
    },
    {
      label: "Facturation",
      items: [
        {
          aria_current: activeNavKey === "consolidation",
          href: "/consolidation",
          icon: "consolidation",
          is_active: activeNavKey === "consolidation",
          key: "consolidation",
          label: "Consolidation",
        },
        {
          aria_current: activeNavKey === "billing",
          href: "/billing",
          icon: "billing",
          is_active: activeNavKey === "billing",
          key: "billing",
          label: "Facturation",
        },
      ],
    },
    {
      label: "Admin",
      items: [
        {
          aria_current: activeNavKey === "admin",
          href: "/admin",
          icon: "admin",
          is_active: activeNavKey === "admin",
          key: "admin",
          label: "Admin",
        },
      ],
    },
  ];
}

function applyActiveNavStateToItem(item, activeNavKey) {
  if (!item || typeof item !== "object") {
    return item;
  }

  const resolvedSubItems = getNavSubItems(item).map((subItem) => applyActiveNavStateToItem(subItem, activeNavKey));
  const resolvedDetailViewLink = typeof item.detail_view_link === "string"
    ? item.detail_view_link.trim().toLowerCase()
    : "";
  const isDirectlyActive = item.key === activeNavKey || resolvedDetailViewLink === activeNavKey;
  const temporaryDisabledItem = typeof item.key === "string"
    ? TEMPORARILY_DISABLED_NAV_ITEM_BY_KEY[item.key.trim()]
    : null;

  return {
    ...item,
    is_active: isDirectlyActive,
    aria_current: isDirectlyActive,
    is_disabled: item.is_disabled === true || Boolean(temporaryDisabledItem),
    disabled_reason: typeof item.disabled_reason === "string" && item.disabled_reason.trim()
      ? item.disabled_reason.trim()
      : temporaryDisabledItem?.disabled_reason,
    ...(resolvedSubItems.length > 0 ? { sub_items: resolvedSubItems } : {}),
  };
}

export function applyActiveNavStateToSections(navSections, activeNavKey) {
  if (!Array.isArray(navSections) || !activeNavKey) {
    return navSections;
  }

  return navSections.map((section) => ({
    ...section,
    items: (section?.items || []).map((item) => applyActiveNavStateToItem(item, activeNavKey)),
  }));
}

function isPortalNavItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = typeof item.key === "string" ? item.key.trim().toLowerCase() : "";
  const itemHref = typeof item.href === "string" ? item.href.trim().toLowerCase() : "";

  if (itemKey === "portal" || itemHref === "/portail") {
    return true;
  }

  return getNavSubItems(item).some((subItem) => isPortalNavItem(subItem));
}

export function injectPortalNavItem(navSections, { hasAccess = true } = {}) {
  if (!Array.isArray(navSections) || navSections.length === 0 || !hasAccess) {
    return navSections;
  }

  const portalNavItem = {
    href: "/portail",
    icon: "portal",
    key: "portal",
    label: "Portail",
  };

  return insertNavItemIntoPortalSection(navSections, portalNavItem, isPortalNavItem, { insertAtStart: true });
}
